'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _axwayReactIntl = require('axway-react-intl');

var _axwayReactIntl2 = _interopRequireDefault(_axwayReactIntl);

var _ContentMessage = require('./ContentMessage');

var _ContentMessage2 = _interopRequireDefault(_ContentMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-unused-expressions:0 */


var ContentLoading = function (_React$Component) {
	_inherits(ContentLoading, _React$Component);

	function ContentLoading(props) {
		_classCallCheck(this, ContentLoading);

		var _this = _possibleConstructorReturn(this, (ContentLoading.__proto__ || Object.getPrototypeOf(ContentLoading)).call(this, props));

		_this.timeout = false;
		_this.state = {
			delay: _this.props.delay,
			deferred: true
		};
		_axwayReactIntl2.default.init(_this);
		return _this;
	}

	_createClass(ContentLoading, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			var _this2 = this;

			this.setState({ deferred: this.state.delay > 0 });

			// If the render is deferred then start a timeout.
			if (this.state.deferred) {
				this.timeout = setTimeout(function () {
					_this2.setState({ deferred: false });
					_this2.timeout = false;
				}, this.state.delay);
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			clearTimeout(this.timeout);
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    message = _props.message,
			    onCancel = _props.onCancel;

			if (this.state.deferred) {
				return null;
			} else {
				return _react2.default.createElement(_ContentMessage2.default, _extends({
					inlineContent: true,
					className: 'contentloading',
					onClose: onCancel,
					imgClass: 'spinner',
					summary: message || this.intl.formatMsg('Loading...')
				}, this.props));
			}
		}
	}]);

	return ContentLoading;
}(_react2.default.Component);

ContentLoading.propTypes = {
	onCancel: _propTypes2.default.func,
	delay: _propTypes2.default.number,
	message: _propTypes2.default.string,
	modal: _propTypes2.default.bool
};

ContentLoading.defaultProps = {
	modal: false,
	delay: 250 // ms
};

var _default = (0, _reactIntl.injectIntl)(ContentLoading);

exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(ContentLoading, 'ContentLoading', 'src/components/ContentLoading.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/ContentLoading.jsx');
}();

;